import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var SvgNetworkPro = function SvgNetworkPro(_a) {
  var _b = _a,
      size = _b.size,
      _b$title = _b.title,
      title = _b$title === void 0 ? "NetworkPro" : _b$title,
      props = __objRest(_b, ["size", "title"]);

  return (
    /* @__PURE__ */
    React.createElement("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      width: size,
      height: size,
      "data-icon-name": title,
      "aria-label": title,
      role: "presentation"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      fillRule: "evenodd",
      d: "M18 17.5l-4.409-1.58c0 .58-.535-.532-.535-.913v-1.3a8.291 8.291 0 001.362-2.843c.367-.298.582-.743.582-1.221V8.07c0-.378-.14-.745-.389-1.03V4.95c.022-.217.108-1.503-.813-2.564C12.999 1.467 11.703 1 9.945 1S6.89 1.466 6.09 2.387c-.92 1.06-.835 2.347-.813 2.564v2.09a1.575 1.575 0 00-.389 1.03v1.572c0 .478.215.923.582 1.221a8.289 8.289 0 001.362 2.844v1.3c0 .38-.205.729-.535.911l-3.47 1.912A3.548 3.548 0 001 20.942V22c0 .5.5 1 1 1h18c.553 0 1.006-.451.963-1.002C20.688 18.42 18.92 17.96 18 17.5z",
      clipRule: "evenodd"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#3C6ED7",
      fillRule: "evenodd",
      d: "M19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
      clipRule: "evenodd"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#435261",
      fillRule: "evenodd",
      d: "M14.5 10.5a4 4 0 100 8 4 4 0 000-8zm-5 4a5 5 0 1110 0 5 5 0 01-10 0z",
      clipRule: "evenodd"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#435261",
      fillRule: "evenodd",
      d: "M17.529 17.529a.667.667 0 000 .942l4 4a.667.667 0 10.942-.942l-4-4a.667.667 0 00-.942 0z",
      clipRule: "evenodd"
    }))
  );
};

var NetworkPro = withIcon(SvgNetworkPro);
export { NetworkPro as default };